import UnauthorizedPage from "./component";
export default UnauthorizedPage;
